import { supabase } from '../lib/supabase'

/**
 * Política de SLA configurable (`Tickets.slaPolicy`): tiempos objetivo por
 * tipo de registro y prioridad.
 * @namespace slaService
 */
const slaService = {
  schemaName: 'Tickets',
  tableName: 'slaPolicy',

  /**
   * Lista las filas configuradas (vacía = se usan los valores por defecto).
   * @returns {Promise<{success: boolean, data: Array|null, error: string|undefined}>}
   */
  async getAll() {
    try {
      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .select(
          'type,priorityId,responseMins,resolutionMins,updatedAt,updatedBy'
        )
      if (error) throw error
      return { success: true, data: data || [] }
    } catch (error) {
      console.error('Error fetching SLA policy:', error)
      return { success: false, data: null, error: error.message }
    }
  },

  /**
   * Guarda (inserta o actualiza) todas las celdas de la matriz.
   * @param {Array<{type: string, priorityId: number, responseMins: number|null,
   *   resolutionMins: number|null}>} rows
   * @param {string} updatedBy - Nombre de quien guarda.
   * @returns {Promise<{success: boolean, error: string|undefined}>}
   */
  async saveAll(rows, updatedBy) {
    try {
      const now = new Date().toISOString()
      const { error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .upsert(
          rows.map((r) => ({ ...r, updatedAt: now, updatedBy })),
          { onConflict: 'type,priorityId' }
        )
      if (error) throw error
      return { success: true }
    } catch (error) {
      console.error('Error saving SLA policy:', error)
      return { success: false, error: error.message }
    }
  },
}

export default slaService
